import { Fragment, h, JSX } from 'preact';

import { AutoSuggest, AutoSuggestProps } from './AutoSuggest';
import { Box } from './Box';

export interface DiscountsSectionProps {
    label: string;
    input: AutoSuggestProps;
}

export const DiscountsSection = (props: DiscountsSectionProps): JSX.Element => (
    <Fragment>
        <Box class='mb-4 last:mb-0'>
            <div class='font-semibold mb-2'>{props.label}</div>
            <div>
                <AutoSuggest {...props.input} />
            </div>
        </Box>
    </Fragment>
);
